import axios from "axios";

export const getRMAs = async (body) => {
  try {
    const res = await axios.post("/api/v1/RMAManagement/getRMAs", body);
    if (res?.status === 200) return res.data.result;
    throw new Error(res);
  } catch (error) {
    console.error(error);
    return null;
  }
};

export const getRMA = async (body) => {
  try {
    const res = await axios.post("/api/v1/RMAManagement/getRMA", body);

    if (res?.status === 200) return res.data.result;
    throw new Error(res);
  } catch (error) {
    console.error(error);
    return null;
  }
};

export const createRMAFromQuote = async (quoteId) => {
  try {
    const res = await axios.post("/api/v1/RMAManagement/createRMAFromQuote", {
      quoteId,
    });
    if (res?.status === 200) return res.data.result;
    throw new Error(res);
  } catch (error) {
    console.error(error);
    return null;
  }
};
export const createRMA = async (body) => {
  try {
    const res = await axios.post("/api/v1/RMAManagement/createRMA", body);
    if (res?.status === 200) return res.data.result;
    throw new Error(res);
  } catch (error) {
    console.error(error);
    return null;
  }
};
export const updateRMA = async (body) => {
  try {
    const res = await axios.post("/api/v1/RMAManagement/updateRMA", body);
    if (res?.status === 200) return res.data.result;
    throw new Error(res);
  } catch (error) {
    console.error(error);
    return null;
  }
};
export const deleteRMA = async (body) => {
  try {
    const res = await axios.post("/api/v1/RMAManagement/deleteRMA", body);
    if (res?.status === 200) return res.data.result;
    throw new Error(res);
  } catch (error) {
    console.error(error);
    return null;
  }
};
export const submitRMA = async (body) => {
  try {
    const res = await axios.post("/api/v1/RMAManagement/submitRMA", body);
    if (res?.status === 200) return res.data;
    throw new Error(res);
  } catch (error) {
    console.error(error);
    return null;
  }
};
